<template>
  <div class="page">
    <div class="box">
      <div class="left-side">
        <!-- S 字段搜索部分 -->
        <div class="search-box">
          <span class="lab">组织名称：</span>
          <el-input
            type="text"
            v-model="keyword"
            @keyup.enter.native="query"
            class="keyword"
            placeholder="组织名称"
          ></el-input>
          <el-button type="button" @click="query" class="search__btn">查询</el-button>
          <el-button @click="$resetTree" class="reset__btn">重置</el-button>
        </div>
        <el-scrollbar>
          <el-tree
            ref="brandTree"
            :data="brandList"
            :props="defaultProps"
            check-on-click-node
            default-expand-all
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            class="brand-tree"
            node-key="brandId"
            @node-click="selectBrand"
            :current-node-key="-1"
            v-loading="isLoading"
          ></el-tree>
        </el-scrollbar>
      </div>
      <div class="right-side">
        <!-- 条件查询部分 -->
        <section class="filter-box">
          <el-form :inline="true" class="filter-form">
            <el-form-item label="门店名称:">
              <el-input v-model="filter.storeName" style="width: 110px;"></el-input>
            </el-form-item>

            <el-form-item label="门店ID:">
              <el-input v-model="filter.storeId" style="width: 110px;" maxlength="9"></el-input>
            </el-form-item>

            <el-form-item label="中台门店ID:">
              <el-input v-model.number="filter.shopId" style="width: 110px;"  maxlength="9"></el-input>
            </el-form-item>

            <el-form-item label="省份:">
              <el-select style="width:110px;" v-model="filter.provinces" filterable placeholder="全部">
                <el-option value="">省份</el-option>
                <el-option
                  v-for="item in provinces"
                  :key="item.id"
                  :label="item.regionName"
                  :value="item.regionCode">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="城市:">
              <el-select style="width:110px;" v-model="filter.citys" filterable placeholder="全部">
                <el-option value="">城市</el-option>
                <el-option
                  v-for="item in citys"
                  :key="item.id"
                  :label="item.regionName"
                  :value="item.regionCode">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="行政区域:">
              <el-select style="width:110px;" v-model="filter.districts" filterable placeholder="全部">
                <el-option value="">区域</el-option>
                <el-option
                  v-for="item in districts"
                  :key="item.id"
                  :label="item.regionName"
                  :value="item.regionCode">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button @click="$_search" class="search__btn">查询</el-button>
              <el-button @click="$_reset" class="reset__btn">重置</el-button>
            </el-form-item>
          </el-form>
        </section>

        <main class="table-box">
          <!-- 数据列表 -->
          <el-table
            class="table-list__box"
            ref="tableList"
            :data="dataList"
            :height="tableHeight"
            v-loading="isLoading"
            stripe
            border
            tooltip-effect="dark"
          >
            <el-table-column
              v-for="column in columns"
              :key="column.key"
              :prop="column.key"
              :label="column.label"
              :width="column.width"
              show-overflow-tooltip
              filter-placement="bottom"
              sortable
              v-if="!column.component"
            ></el-table-column>
            <el-table-column
              :prop="column.key"
              :label="column.label"
              :width="column.width"
              sortable
              v-else
            >
              <template slot-scope="scope">
                <component :is="column.component" :row="scope.row"></component>
              </template>
            </el-table-column>

            <div v-show="!isLoading" class="table-list__empty" slot="empty"></div>
          </el-table>
        </main>
        <!-- 分页 -->
        <div class="pagination__wrapper">
          <cd-pagination
            ref="pager"
            :total="pagination.total"
            :currPage="pagination.pageNow"
            :pageSize="pagination.pageSize"
            @changepage="$_changeCurrent"
            @changesize="$_changeSize"
            :explainShow="true"
            @refresh="$_getStoreList"
          ></cd-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import * as Utils from "@/plugins/utils";
import resize from "@/mixins/resize";

const columns = [
  { key: "brandName", label: "品牌名称"},
  { key: "brandId", label: "品牌ID", width: 140 },
  { key: "storeName", label: "门店名称", width: 160 },
  { key: "storeId", label: "门店ID", width: 140},
  { key: "shopId", label: "中台门店ID", width: 160 },
  { key: "provinceName", label: "省份", width: 140 },
  { key: "cityName", label: "城市", width: 140 },
  { key: "areaName", label: "行政区域", width: 140 },
];
export default {
  name: "organization-basic",
  mixins: [resize],
  props: {
    platformKey: { type: String, default: "" },
    provinces: { type: Array, default: [] },
  },
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "bName"
      },
      list: [],
      currSelect: null,//当前选中的品牌
      keyword: '',
      filter: {
        storeName: "",
        storeId: "",
        shopId: "",
        provinces: "", // 全部省份
        citys: "", // 全部城市
        districts: "", // 全部行政区域
      },
      citys: [],//城市列表
      districts: [],//地区列表
      tableHeight: null,
      isLoading: false,
      dataList: [],
      columns,
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      }
    }
  },
  computed: {
    brandList(){
      if (this.list.length > 0) {
        let children = this.list.map(ele => {
          ele.bName = '【品牌】' + ele.brandName;
          return ele;
        });
        return [{
          bName: '【运营商】' + this.list[0].platformName,
          brandId: -1,
          platformKey: this.list[0].platformKey,
          children
        }];
      }
      return [];
    }
  },
  watch: {
    'filter.provinces'(val) {
      if(val != ''){
        this.$service.post("getRegionData", {
          level: 'city',
          parentRegionCodeId: -1,
          parentRegionCode: val
        }).then(result => {
          if (result.$.checkResult(result, true)) {
            this.citys = result.data.concat([]);
          }
        });
      }else{
        this.citys = [];
      }
      //重置
      this.filter.citys = '';
      this.filter.districts  = '';
    },
    'filter.citys'(val) {
      if(val != ''){
        this.$service.post("getRegionData", {
          level: 'area',
          parentRegionCodeId: -1,
          parentRegionCode: val
        }).then(result => {
          if (result.$.checkResult(result, true)) {
            this.districts = result.data.concat([]);
          }
        });
      }else{
        this.districts = [];
      }
      //重置
      this.filter.districts  = '';
    },
  },
  methods:{
    query() {
      if (this.brandList.length > 0) {
        let keyword = this.keyword;
        this.$refs.brandTree.filter(keyword);
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.bName.indexOf(value) !== -1;
    },
    $resetTree(){
      this.keyword = '';
      this.$refs.brandTree.filter(this.keyword);
    },
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      let reg = /[^\d.]/g;
      if(this.filter.shopId && new RegExp(reg).test(this.filter.shopId)){
        $MessageBox.alert({
          content: `<div>中台门店id需填数字！</div>`,
        });
      }else{
        this.$_getStoreList();
      }
    },
    // 重置
    $_reset() {
      this.filter.storeName = "";
      this.filter.storeId = "";
      this.filter.provinces = "";
      this.filter.citys = "";
      this.filter.districts = "";
      this.filter.shopId = "";
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getStoreList();
    },
    // 查询门店列表
    $_getStoreList() {
      this.isLoading = true;
      let brandId = this.currSelect&&this.currSelect.data.brandId != -1?this.currSelect.data.brandId:null
      const postData = {
        platformName: this.brandList.length > 0 ? this.brandList[0].platformName : '',
        platformKey: this.brandList.length > 0 ? this.brandList[0].platformKey : '',
        brandId,
        storeName: this.filter.storeName,
        provinceCode: this.filter.provinces,
        cityCode: this.filter.citys,
        areaCode: this.filter.districts,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize
      };
      if(this.filter.storeId != ''){
        postData.storeId = this.filter.storeId;
      }
      if(this.filter.shopId != ''){
        postData.shopId = Number(this.filter.shopId);
      }
      this.lastFilter = JSON.parse(JSON.stringify(postData));
      this.$service.post("pagingShop", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    // 查询运营商列表
    $_getPlatformList() {
      this.isLoading = true;
      this.$refs.tableList.clearSort();
      const postData = {
        storeName: this.filter.storeName,
        storeId: this.filter.storeId,
        provinceCode: this.filter.provinces,
        cityCode: this.filter.citys,
        areaCode: this.filter.districts,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize
      };
      this.$service.post("getStores", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getStoreList();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getStoreList();
    },
    // 选中品牌
    selectBrand(data, node){
      this.isLoading = true;
      this.currSelect = node;
      this.pagination.pageNow = 1;
      let postData = {
        platformKey: this.platformKey,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize
      };
      if(node && node.data.brandId && node.data.brandId !=-1) {
        postData.brandId=node.data.brandId;
      }
      this.$service.post("pagingShop", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    }
  },
  async created(){
    
    this.isLoading = true;
    // 请求品牌列表
    let result = await this.$service.post("findByPlatformKey", {platformKey: this.platformKey});
    if (result.status === 1) {
      this.list = result.data.concat([]);
      // 请求运营商下所有商店
      this.selectBrand();
      this.$nextTick(function(){
        this.$refs.brandTree.setCurrentKey(-1);
      });
    }
  },
  mounted(){
    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
  }
}
</script>

<style lang="scss" scoped>
.page{
  height: 100%;
}
.box{
  display: flex;
  height: 100%;
  .left-side{
    width: 388px;
    height: 100%;
    background:rgba(249,249,249,1);
    border:1px solid #eee;
    box-sizing: border-box;
    .search-box{
      font-size:12px;
      color: #68768A;
      height: 68px;
      line-height: 68px;
      border-bottom: 1px solid #eee;
      .lab{
        padding-left: 20px;
      }
      .keyword{
        display: inline-block;
        width: 110px;
        margin-right: 30px;
      }
      .el-button{
        vertical-align: middle;
      }
    }
    /deep/ .brand-tree{
      display: inline-block;
      min-width: 100%;
      padding: 10px 0 0 20px;
      min-height: 200px;
      .el-tree-node__children{
        .el-tree-node__label{
          padding-left: 16px;
        }
        .is-leaf{
          display: none;
        }
      }
      .is-current>.el-tree-node__content{
        background:rgba(24,149,221,1);
        color: #fff;
        .el-tree-node__expand-icon{
          color: #fff;
        }
      }
    }
    /deep/ .el-scrollbar{
      height: calc(100% - 68px);
      .el-scrollbar__wrap{
        height: calc(100% + 17px);
      }
      .el-scrollbar__view{
        padding-bottom: 35px;
      }
    }
  }
  .right-side{
    flex: 1;
    background:rgba(245,246,247,1);
    margin-left: 12px;
    border:1px solid #eee;
    display: flex;
    flex-direction: column;
    width: 0;
    .filter-box {
      color: #68768a;
      background-color: #f5f6f7;
      padding: 20px 20px 10px 20px;

      .top-btns {
        min-height: 50px;
      }
    }
    .table-box{
      width: 100%;
      height: 100vh;
      border-top: 1px solid #eee;
      overflow-x: auto;
      position: relative;
    }
  }
}
</style>
